module.exports = __webpack_public_path__ + "img/3_78.1aa2e44e.png";